import { Deserializable } from '../deserializable';

export class OptionListItemDto implements Deserializable {
  public ID: string;
  public Value: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
